import React, { ReactNode, ReactElement } from 'react';

interface ConditionProps {
  match?: boolean;
  children?: ReactNode;
}

const Condition = ({ match, children }: ConditionProps): ReactElement => {
  return match ? <>{children}</> : null;
};

export { Condition };
